import { render } from "./ToolsInventory.vue?vue&type=template&id=627f2b11"
import script from "./ToolsInventory.vue?vue&type=script&lang=js"
export * from "./ToolsInventory.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__